import EmptyScreenImage from '@assets/images/empty-lead-sources.svg';

interface EmptyScreenProps {
  title: string;
  description: string;
}

const EmptyScreen = ({ title, description }: EmptyScreenProps) => (
  <div className="flex flex-1 flex-col items-center justify-center gap-2">
    <img src={EmptyScreenImage} alt="Empty Screen" />
    <div className="flex flex-col items-center justify-center gap-0.5">
      {title && <h2 className="text-center text-xl font-medium">{title}</h2>}
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>
  </div>
);

export default EmptyScreen;
